<template>
    <form-accordion
        name="agent-brokers"
        section="Agent / Brokers on This Deal"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <form-row title="Seller's Broker(s)" :label_align_top="true">
            <div class="flex flex-col flex-1">
                <seller-broker
                    v-for="(seller_broker, index) in seller_brokers"
                    :key="seller_broker.id || seller_broker.key"
                    :index="index"
                    :count="seller_brokers.length"
                    :contact="seller_broker"
                    :broker="broker"
                    :read_only="read_only"
                    @delete="deleteSellerBroker"
                />

                <div class="flex flex-1 justify-end">
                    <button v-if="! read_only"
                        type="button"
                        class="flex items-center text-xs uppercase text-blue-500 hover:text-blue-600 leading-none focus:shadow-none tracking-wide font-semibold sm:ml-46 my-4"
                    >
                        <span class="text-lg font-bold mr-2">+</span>

                        <span class="inline-block py-2 cursor-pointer select-none"
                            @click="addSellerBroker"
                        >
                            Add Seller's Broker
                        </span>
                    </button>
                </div>
            </div>
        </form-row>

        <form-row title="Buyer's Broker(s)" :label_align_top="true">
            <div class="flex flex-col flex-1">
                <buyer-broker
                    v-for="(buyer_broker, index) in buyer_brokers"
                    :key="buyer_broker.id || buyer_broker.key"
                    :index="index"
                    :count="buyer_brokers.length"
                    :contact="buyer_broker"
                    :broker="broker"
                    :read_only="read_only"
                    @delete="deleteBuyerBroker"
                />

                <div class="flex flex-1 justify-end">
                    <button v-if="! read_only"
                        type="button"
                        class="flex items-center text-xs uppercase text-blue-500 hover:text-blue-600 leading-none focus:shadow-none tracking-wide font-semibold sm:ml-46 my-4"
                    >
                        <span class="text-lg font-bold mr-2">+</span>

                        <span class="inline-block py-2 cursor-pointer select-none"
                            @click="addBuyerBroker"
                        >
                            Add Buyer's Broker
                        </span>
                    </button>
                </div>
            </div>
        </form-row>
    </form-accordion>
</template>

<script>
import SellerBroker from './seller-broker.vue';
import BuyerBroker from './buyer-broker.vue';

export default {
    components: {
        SellerBroker,
        BuyerBroker,
    },

    props: {
        url: {},
        closed: { default: true },
        broker: { default: () => ({}) },
        contacts_seller_brokers: { default: () => [] },
        contacts_buyer_brokers: { default: () => [] },
        read_only: { default: false },
    },

    data() {
        return {
            seller_brokers: this.contacts_seller_brokers,
            buyer_brokers: this.contacts_buyer_brokers,
        }
    },

    computed: {
        our_sale() {
            return store.state.our_sale;
        },
        our_purchase() {
            return store.state.our_purchase;
        },
        default_seller_broker() {
            return this.our_sale ? this.getDefaultContact() : this.getEmptyContact();
        },
        default_buyer_broker() {
            return this.our_purchase ? this.getDefaultContact() : this.getEmptyContact();
        },
    },

    methods: {
        getEmptyContact() {
            return {
                id: null,
                key: 'key_' + this.getRandomKey(),
                user_id: null,
                name: null,
                email: null,
                phone: null,
                external_id: null,
                company: null,
                company_external_id: null,
            };
        },
        getDefaultContact() {
            return {
                id: null,
                key: 'key_' + this.getRandomKey(),
                user_id: this.broker.id,
                name: this.broker.name,
                email: this.broker.email,
                phone: this.broker.settings.phone,
                external_id: this.broker.settings.mls_number,
                company: this.broker.settings.office_name,
                company_external_id: this.broker.settings.office_id,
            };
        },
        getRandomKey() {
            return Math.floor(Math.random() * (999999 - 1) + 1);
        },
        addBuyerBroker() {
            this.buyer_brokers.push(this.getEmptyContact());
        },
        addBuyerBrokerDefault() {
            this.buyer_brokers.unshift(this.getDefaultContact());
        },
        addSellerBroker() {
            this.seller_brokers.push(this.getEmptyContact());
        },
        addSellerBrokerDefault() {
            this.seller_brokers.unshift(this.getDefaultContact());
        },
        deleteBuyerBroker(key) {
            const index = this.buyer_brokers
                .findIndex(contact => contact.id == key || contact.key == key);

            if (index > -1) {
                this.buyer_brokers.splice(index, 1);
            }
        },
        deleteBuyerBrokerDefault() {
            const index = this.buyer_brokers
                .findIndex(contact => contact.user_id == this.broker.id);

            if (index > -1) {
                this.buyer_brokers.splice(index, 1);
            }
        },
        deleteSellerBroker(key) {
            const index = this.seller_brokers
                .findIndex(contact => contact.id == key || contact.key == key);

            if (index > -1) {
                this.seller_brokers.splice(index, 1);
            }
        },
        deleteSellerBrokerDefault() {
            const index = this.seller_brokers
                .findIndex(contact => contact.user_id == this.broker.id);

            if (index > -1) {
                this.seller_brokers.splice(index, 1);
            }
        },
        buyerBrokersIncludeDefault() {
            return this.buyer_brokers.find(contact => contact.user_id == this.broker.id);
        },
        sellerBrokersIncludeDefault() {
            return this.seller_brokers.find(contact => contact.user_id == this.broker.id);
        },
        submit() {
            let form = document.querySelector('#agent-brokers');
            let data = new FormData(form);

            axios.post(this.url, data)
                .then(response => {
                    this.seller_brokers = response.data.contacts_seller_brokers;
                    this.buyer_brokers = response.data.contacts_buyer_brokers;
                }).catch(error => {
                    console.log(error.response);
                });
        },
    },

    watch: {
        our_sale(val) {
            if (this.sellerBrokersIncludeDefault()) {
                if (! val) {
                    this.deleteSellerBrokerDefault();
                }
            } else {
                console.log('adding seller broker default');
                this.addSellerBrokerDefault();
                this.$nextTick(() => {
                    this.submit();
                });
            }
        },
        our_purchase(val) {
            if (this.buyerBrokersIncludeDefault()) {
                if (! val) {
                    this.deleteBuyerBrokerDefault();
                }
            } else {
                this.addBuyerBrokerDefault();
                this.$nextTick(() => {
                    this.submit();
                });
            }
        },
    },
}
</script>
